(function () {
  function scrollToChat() {
    var chat = document.getElementById('tcb-ai-advisor-chat');
    if (chat) chat.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  document.querySelectorAll('[data-tcb-aia-start]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (el.getAttribute('href') === '#tcb-ai-advisor-chat') {
        e.preventDefault();
        scrollToChat();
      }
    });
  });

  document.querySelectorAll('[data-tcb-aia-prompt]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var prompt = btn.getAttribute('data-tcb-aia-prompt');
      scrollToChat();
      var frame = document.querySelector('[data-tcb-aia-chat-frame]');
      if (frame && frame.contentWindow) {
        frame.contentWindow.postMessage({ type: 'tcb-advisor-prompt', prompt: prompt }, '*');
      }
    });
  });

  document.querySelectorAll('[data-tcb-tidio-chat]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (window.tidioChatApi) window.tidioChatApi.open();
    });
  });

  var frame = document.querySelector('[data-tcb-aia-chat-frame]');
  var fallback = document.querySelector('[data-tcb-aia-chat-fallback]');
  if (frame && fallback) {
    frame.addEventListener('error', function () {
      frame.hidden = true;
      fallback.hidden = false;
    });
  }
})();
